"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spinner = void 0;
/* stylelint-disable-next-line keyframes-name-pattern */
var react_1 = __importStar(require("react"));
var css_1 = require("@emotion/css");
var design_system_foundations_1 = require("@contrast-security-inc/design-system-foundations");
var messages = __importStar(require("../translations"));
var rotate = (0, css_1.keyframes)({
    from: {
        transform: 'rotate(0deg)',
    },
    to: {
        transform: 'rotate(360deg)',
    },
});
// min width and height needed to prevent distortion when spinner is resized in a flex container
var spinnerStyle = function (_a) {
    var size = _a.size, selectedTheme = _a.selectedTheme;
    return (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    height: ", ";\n    width: ", ";\n    min-height: ", ";\n    min-width: ", ";\n    /* stylelint-disable-next-line */\n    border: 5px solid ", ";\n    border-top-color: ", ";\n    border-radius: 50%;\n    display: inline-block;\n    box-sizing: border-box;\n    animation: ", " 1s linear infinite;\n  "], ["\n    height: ", ";\n    width: ", ";\n    min-height: ", ";\n    min-width: ", ";\n    /* stylelint-disable-next-line */\n    border: 5px solid ", ";\n    border-top-color: ", ";\n    border-radius: 50%;\n    display: inline-block;\n    box-sizing: border-box;\n    animation: ", " 1s linear infinite;\n  "])), (0, design_system_foundations_1.mapCssValue)(size), (0, design_system_foundations_1.mapCssValue)(size), (0, design_system_foundations_1.mapCssValue)(size), (0, design_system_foundations_1.mapCssValue)(size), (0, design_system_foundations_1.getThemeValue)(selectedTheme, {
        light: design_system_foundations_1.theme.color.neutral50,
        dark: design_system_foundations_1.darkTheme.color.prussianBlue,
    }), (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: design_system_foundations_1.theme.color.teal50, dark: design_system_foundations_1.darkTheme.color.blueGray50 }), rotate);
};
exports.Spinner = (0, react_1.forwardRef)(function (_a, ref) {
    var className = _a.className, _b = _a.size, size = _b === void 0 ? '48px' : _b, testId = _a.testId, ariaLabel = _a.ariaLabel, props = __rest(_a, ["className", "size", "testId", "ariaLabel"]);
    var selectedTheme = (0, design_system_foundations_1.useThemeContext)().selectedTheme;
    var classes = (0, css_1.cx)(spinnerStyle({ size: size, selectedTheme: selectedTheme }), className, 'ds-spinner');
    var formatMessage = (0, design_system_foundations_1.useLocalizationContext)().formatMessage;
    return (react_1.default.createElement("div", __assign({ className: classes, ref: ref, "data-testid": testId, "aria-label": ariaLabel || formatMessage(messages, 'loading'), "aria-busy": "true", role: "status" }, props)));
});
exports.Spinner.displayName = 'Spinner';
var templateObject_1;
